import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import { useFetchEventSession } from 'actions/eventSessions';
import { useGetTabInfo } from 'screens/AssetManager';
import SessionHeader from './SessionHeader';
import SessionDetailsPage from './SessionDetailsPage';
import SessionAttendeesPage from './SessionAttendeesPage';
import { getSessionIsActiveTab, getSessionTabLink } from '../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function SessionManager(_ref) {
  var _ref$isNested = _ref.isNested,
    isNested = _ref$isNested === void 0 ? true : _ref$isNested,
    overallContentAudienceType = _ref.overallContentAudienceType,
    sessionId = _ref.sessionId,
    eventId = _ref.eventId,
    _ref$stickyHeaderComp = _ref.stickyHeaderCompensation,
    stickyHeaderCompensation = _ref$stickyHeaderComp === void 0 ? 0 : _ref$stickyHeaderComp;
  var location = useLocation();
  var navigate = useNavigate();

  // Whether the SessionManager is nested e.g. inside the Asset Manager or in a Modal with Heading card
  // which determines some of the UI (e.g. heading levels)

  var isEditMode = sessionId !== 'new';
  var availableTabs = useMemo(function () {
    var tabs = ['details'];
    if (isEditMode) {
      tabs.push('attendees');
    }
    return tabs;
  }, [isEditMode]);
  var _useGetTabInfo = useGetTabInfo({
      getTabLink: getSessionTabLink,
      getIsActiveTab: getSessionIsActiveTab,
      location: location,
      tabs: availableTabs
    }),
    tabLinks = _useGetTabInfo.tabLinks,
    activeTab = _useGetTabInfo.activeTab;
  useEffect(function () {
    var _queryparse = queryparse(location.search),
      currentTab = _queryparse.sessionTab;
    if (currentTab !== null && currentTab !== undefined && !availableTabs.includes(currentTab)) {
      navigate(getSessionTabLink({
        tabName: 'details',
        location: location
      }), {
        replace: true
      });
    }
  }, [availableTabs, location, navigate]);
  var _useFetchEventSession = useFetchEventSession({
      eventId: eventId,
      sessionId: sessionId,
      enabled: isEditMode
    }),
    session = _useFetchEventSession.data,
    isSessionLoading = _useFetchEventSession.isLoading,
    isSessionError = _useFetchEventSession.isError;
  var renderActiveTab = function renderActiveTab() {
    var _session$attendeesCou;
    switch (activeTab) {
      case 'details':
        return /*#__PURE__*/_jsx(SessionDetailsPage, {
          isNested: isNested,
          isEditMode: isEditMode,
          isLoading: isSessionLoading,
          isError: isSessionError,
          eventId: eventId,
          session: session
        });
      case 'attendees':
        return /*#__PURE__*/_jsx(SessionAttendeesPage, {
          isNested: isNested,
          eventId: eventId,
          sessionId: sessionId,
          sessionCapacity: session === null || session === void 0 ? void 0 : session.capacity,
          sessionAttendeesCount: (_session$attendeesCou = session === null || session === void 0 ? void 0 : session.attendeesCount) !== null && _session$attendeesCou !== void 0 ? _session$attendeesCou : 0,
          overallContentAudienceType: overallContentAudienceType
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SessionHeader, {
      sessionId: sessionId,
      isNested: isNested,
      session: session,
      tabLinks: tabLinks,
      stickyDistance: stickyHeaderCompensation
    }), renderActiveTab()]
  });
}
export default SessionManager;